import React from 'react'
import { Link, useLocation } from "react-router-dom";
import "../../assets/styles/index.css"
import logoImg from "../../assets/img/logo.svg"

function Navbar() {
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  const location = useLocation();
  return (
    <nav className="fixed top-0 z-50 flex flex-wrap items-center justify-between w-full px-2 py-3 bg-blue-950 navbar-expand-lg">
        <div className="container flex flex-wrap items-center justify-between px-4 mx-auto">
          <div className="relative flex justify-between w-full lg:w-auto lg:static lg:block lg:justify-start">
            <Link
              to="/"
              className="inline-block py-2 mr-4 leading-relaxed whitespace-nowrap"
            >
              <img src={logoImg} alt="logo" className='h-6'/>
            </Link>
            <button
              className="block px-3 py-1 text-xl leading-none bg-transparent border-transparent outline-none cursor-pointer lg:hidden focus:outline-none"
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              <i className="fas fa-bars" style={{color: "white"}}></i>
            </button>
          </div>
          <div
            className={
              "lg:flex flex-grow items-center bg-blue-950 lg:bg-opacity-0 lg:shadow-none" +
              (navbarOpen ? " block" : " hidden")
            }
            id="example-navbar-warning"
          >

            <ul className="flex flex-col list-none lg:flex-row lg:ml-auto">
              <li className="flex items-center justify-center">
                <Link to="/">
                  <span className="flex items-center px-3 py-4 text-sm text-white uppercase hover:font-bold lg:py-2">Home</span>
                </Link>
              </li>

              <li className="flex items-center justify-center">
                <Link to="/product" className={location.pathname === '/product' ? 'font-bold' : ''}>
                  <span className="flex items-center px-3 py-4 text-sm text-white uppercase hover:font-bold lg:py-2">Product</span>
                </Link>
              </li>

              {/* <li className="flex items-center justify-center">
                <Link to="/usecase" className={location.pathname === '/usecase' ? 'font-bold' : ''}>
                  <span className="flex items-center px-3 py-4 text-sm text-white uppercase hover:font-bold lg:py-2">Use Case</span>
                </Link>
              </li> */}

              <li className="flex items-center justify-center">
                <Link to="/about" className={location.pathname === '/about' ? 'font-bold' : ''}>
                  <span className="flex items-center px-3 py-4 text-sm text-white uppercase hover:font-bold lg:py-2">About</span>
                </Link>
              </li>

              <li className="flex items-center justify-center">
                <Link to="/contact" className={location.pathname === '/contact' ? 'font-bold' : ''}>
                  <span className="flex items-center px-3 py-4 text-sm text-white uppercase hover:font-bold lg:py-2">Contact</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
  )
}

export default Navbar